import { TEBEX_PUBLIC_TOKEN, TEBEX_HEADLESS_API, WEBSITE_URL } from '../config';

const BASE = () => `${TEBEX_HEADLESS_API}/accounts/${TEBEX_PUBLIC_TOKEN}`;

async function tebexFetch(url, options = {}) {
  const response = await fetch(url, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ message: response.statusText }));
    throw new Error(err.message || err.detail || `Tebex API error ${response.status}`);
  }
  return response.json();
}

export function getCategories() {
  return tebexFetch(`${BASE()}/categories?includePackages=1`);
}

export function getPackages() {
  return tebexFetch(`${BASE()}/packages`);
}

export function createBasket(username) {
  return tebexFetch(`${BASE()}/baskets`, {
    method: 'POST',
    body: JSON.stringify({
      username,
      return_url: `${WEBSITE_URL}/shop?purchase=success`,
      complete_url: `${WEBSITE_URL}/shop?purchase=success`,
      cancel_url: `${WEBSITE_URL}/shop?purchase=cancelled`,
      complete_auto_redirect: true,
    }),
  });
}

export function addPackageToBasket(basketIdent, packageId, quantity = 1) {
  return tebexFetch(`${TEBEX_HEADLESS_API}/baskets/${basketIdent}/packages`, {
    method: 'POST',
    body: JSON.stringify({ package_id: packageId, quantity }),
  });
}

export function removePackageFromBasket(basketIdent, packageId) {
  return tebexFetch(`${TEBEX_HEADLESS_API}/baskets/${basketIdent}/packages/remove`, {
    method: 'POST',
    body: JSON.stringify({ package_id: packageId }),
  });
}

export function getBasket(basketIdent) {
  return tebexFetch(`${TEBEX_HEADLESS_API}/baskets/${basketIdent}`);
}
